import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconZoomOutSvg } from "./IconZoomOutSvg.mjs";
const IconZoomOut = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconZoomOutSvg, ...svgProps }) });
export {
  IconZoomOut
};
